import { DefaultTheme } from 'styled-components';

export default function setupFontsByTheme(theme: DefaultTheme) {
  document.documentElement.style.setProperty('--theme-font-family-regular', theme.typography.fontFamilyRegular);
  document.documentElement.style.setProperty('--theme-font-family-bold', theme.typography.fontFamilyBold);
}
